import { useState, useEffect } from 'react'
import firebase from '../firebase/compat'
import { client } from './Client'

/**
 * Fetches the cross-company participatieladder benchmark via the
 * `participationLadderBenchmark` Cloud Function. Growth is measured in treden
 * (average step change begin → current per organisation), not in %.
 * The callable verifies tenant membership server-side and anonymises every
 * non-caller organisation, so the result is safe to render as-is.
 *
 * AI-CONTEXT: See docs/features/participation-ladder-benchmark.md
 *
 * @param {boolean} [enabled] - Skip the fetch entirely when false (e.g. module off)
 * @param {{ includeExplanation?: boolean }} [options] - includeExplanation is detail-page only (expensive top-vs-rest comparison)
 * @returns {{ benchmark: object | null, loading: boolean }}
 */
const useParticipationBenchmark = (enabled = true, { includeExplanation = false } = {}) => {
  const [benchmark, setBenchmark] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!enabled) return

    let active = true
    setLoading(true)
    setBenchmark(null)

    const participationLadderBenchmark = firebase
      .app()
      .functions('europe-west1')
      .httpsCallable('participationLadderBenchmark')

    participationLadderBenchmark({ callerCompanyId: client, includeExplanation })
      .then((result) => { if (active) setBenchmark(result.data) })
      .catch((err) => console.error('useParticipationBenchmark error:', err))
      .finally(() => { if (active) setLoading(false) })

    return () => { active = false }
  }, [enabled, includeExplanation])

  return { benchmark, loading }
}

export default useParticipationBenchmark
